import requests from '../../../request'

const baseUrl = '/admin/order/aftersale/retail';
const ContentTypeEnum = {
    // json
    JSON: 'application/json;charset=UTF-8',
}

/**
 * 售后订单列表
 * @param {Object} data { afterSaleNo, orderNo, afterSaleType, status, merchId, applyTimeStart, applyTimeEnd, pageIndex, pageSize }
 */
export function queryList(data) {
    return requests(
        {
            url: baseUrl + '/query',
            data,
            method: 'post'
        },
        {
            contentType: ContentTypeEnum.JSON,
        },
    );
}

/**
 * 售后订单详情
 * @param {String} afterSaleId 售后单ID（雪花ID，字符串）
 */
export function queryDetail(afterSaleId) {
    return requests(
        {
            url: baseUrl + '/' + encodeURIComponent(afterSaleId),
            method: 'get'
        },
    );
}

/**
 * 审核通过
 */
export function auditPass(data) {
    return requests(
        {
            url: baseUrl + '/audit/pass',
            data,
            method: 'patch'
        },
        {
            contentType: ContentTypeEnum.JSON,
        },
    );
}

/**
 * 审核拒绝
 */
export function auditReject(data) {
    return requests(
        {
            url: baseUrl + '/audit/reject',
            data,
            method: 'patch'
        },
        {
            contentType: ContentTypeEnum.JSON,
        },
    );
}

/**
 * 打款/退款
 */
export function refund(data) {
    return requests(
        {
            url: baseUrl + '/refund',
            data,
            method: 'patch'
        },
        {
            contentType: ContentTypeEnum.JSON,
        },
    );
}

/**
 * 取消售后
 */
export function cancel(afterSaleId) {
    return requests(
        {
            url: baseUrl + '/' + encodeURIComponent(afterSaleId),
            method: 'delete'
        },
    );
}
